import React from 'react';

const GenreDetail = () => {
    return (
        <div className="container">
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="row">
                    <div className="col">
                        <h1 className="text-center"><i className="fas fa-times text-danger" /></h1>
                        <h4 className="text-center mt-3">Sorry dude, belum jadi developernya lagi di jamban :)</h4>
                        <p className="text-center">Balik lagi nanti ya...</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GenreDetail;
